import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Route, Router } from '@angular/router';
import { data } from 'jquery';
import { User } from '../user';
import { AuthService } from '../auth.service';

@Component({
  selector: 'app-passwordreset',
  templateUrl: './passwordreset.component.html',
  styleUrls: ['./passwordreset.component.css']
})
export class PasswordresetComponent implements OnInit {

  loginForm : FormGroup;
  hide = true;
  chide = true;
  constructor(private _authService : AuthService, private _router : Router) { }
  user = new User();

  ngOnInit() {
    this.loginForm = new FormGroup({
      email : new FormControl('',[Validators.required]),
      password : new FormControl('', [Validators.required, Validators.minLength(6)]),
      confirmPassword : new FormControl('', [Validators.required, Validators.minLength(6)])
    });
  }

  resetPassword() {
this._authService.passwordReset(this.user).subscribe(
    data =>{
      console.log("success"+data);
      alert("Password Reset Success!!!");
      this._router.navigate(['/login']);
    },
    error => {
      console.log("error occurred"+error);
    }
)
  }

}
